import { useEffect } from 'react';

export const useScrollToTopFixIOS = (
  scrollRef: React.RefObject<HTMLDivElement | null>
) => {
  // on iOS window.scrollTo doesn't seem to work as expected https://forums.developer.apple.com/forums/thread/703294
  // using window.scroll(0, 0) will unexpectedly not work/navigate the user to the bottom of
  // the page, see details here https://hungryroot.atlassian.net/browse/WEB-3226
  useEffect(() => {
    scrollRef?.current?.scrollIntoView({ block: 'start' });
  }, [scrollRef]);
};
